import { UIElement } from './uiElement';
import { List } from '../..';
import { IUIElementOptions } from '../../../interfaces/options';
import { SelectionMode } from '../../../enums';
import { IKeyValue } from '../../../interfaces';
import { Templates } from '../../../compile';
import { ID } from '../../../const';

export class Radio<T> extends UIElement<T> {
	private list: List<T>;
	constructor(
		id: string,
		label: string,
		value: T | KnockoutObservable<T>,
		items: T[],
		options?: IUIElementOptions
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				widget: {
					widget: Templates.widgets_radio
				}
			},
			options || {}
		);
		super(id, label, value, options);
		this.list = new List({
			dataSource: {
				data: items
			},
			selectionMode: SelectionMode.SINGLE
		});
		this.list.onSelectionToggled.subscribe(data => {
			this.value(this.list.selectedItems[0]);
		});
		let _value: T;
		if ((_value = ko.unwrap(value))) {
			this.list.toggleSelection(_value);
		}
	}
	public getSelectedItem(): T {
		return this.list.selectedItems[0];
	}
	public selectItem(item: T | string, property?: string) {
		this.list.selectItem(item, property);
	}
	public selectBy(value: any, property: string = ID.ID): T {
		return this.list.selectBy(value, property);
	}
	public clearSelection(): void {
		this.list.clearSelection();
	}
	//overwrite
	public serialize(serializeObject: IKeyValue<any>): IKeyValue<any> {
		serializeObject[this.id] = this.getSelectedItem();
		return serializeObject;
	}
}
